import { atom } from 'recoil';

const lastAddedActionId = atom<string | null>({
  key: 'lastAddedFlowActionId',
  default: null,
});

export default lastAddedActionId;
